import path from 'ramda/src/path'
import moduleDescriptions from 'root/src/shared/descriptions/modules'

export default (state, props) => {
	const { moduleId, fieldDescPath } = props

	const field = path(
		[moduleId, ...fieldDescPath],
		moduleDescriptions,
	)

	if (typeof field === 'function') {
		return field(state, props)?.debounceInput
	}

	return field?.debounceInput
}
